module.exports = __webpack_public_path__ + "img/currents-providers.aafc185.webp";